// extracted by mini-css-extract-plugin
module.exports = {"wrapperTags":"Tags_wrapperTags__1N123","type":"Tags_type__17KH_","tag":"Tags_tag__ogFdB"};